export default __webpack_public_path__ + "static/media/edit_icon.e4c3102a.svg";